// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__wk1SF","buttons":"PendingPaymentAlert_buttons__3hKwf"};